import React from "react";

const PaymentInformation = () => {
  return <div>Payment Information</div>;
};

export default PaymentInformation;
